import React from 'react'

import { ReactComponent as Icon } from '../../../assets/icons/search.svg'

import './SearchField.scss'

export const SearchField = ({
  placeholder,
  value,
  onChange,
}) => {
  return (
    <label className="search-field-container">
      <input
        type="text"
        placeholder={ placeholder }
        value={ value }
        onChange={ onChange }
      />
      <Icon />
    </label>
  )
}